import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon, PlayIcon } from 'lucide-react';
import { Sparkle } from './Sparkle';
import { YouTubeEmbed } from './YouTubeEmbed';
const testimonials = [{
  videoId: 'LiYEUeGBYW0',
  title: 'Wie Renata mit Remote Sales ihren finanziellen Durchbruch geschafft hat',
  text: 'Jahrelang arbeitete Renata in einer Apotheke und baute sich parallel etwas im Network Marketing auf. Trotz viel Einsatz blieben die fünfstelligen Payouts aus. Remote Sales war für sie komplettes Neuland – bis sie mit unserer Unterstützung direkt mit ihrer ersten Bewerbung ihren ersten Closer-Job bekam.',
  bullets: ['Direkter Einstieg: Mit ihrer ersten Bewerbung sicherte sie sich ihren ersten Job als Closerin.', '14.000 €+ Payout: Bereits nach fünf Monaten erreichte sie ihr erstes fünfstelliges Monatsergebnis.', 'Komplett ortsunabhängig: Heute arbeitet Renata von überall auf der Welt, zeitlich flexibel und ohne starre Strukturen. Und ihr Alltag fühlt sich viel leichter an.']
}, {
  videoId: 'GouEvF4N4zo',
  title: 'Wie Anne als absolute Quereinsteigerin zur erfolgreichen Remote-Closerin wurde',
  text: 'Anne kam von der Bundeswehr und hatte null Erfahrung im Sales oder Remote Closing. Ihr Ziel war klar: raus aus starren Strukturen und rein in ein Leben mit mehr Freiheit, Reisen und Selbstbestimmung. Nach ihrem Start bei den Hot Sales Girls ging plötzlich alles ziemlich schnell.',
  bullets: ['Vom Quereinstieg zum ersten Remote-Job: Nach nur drei Monaten startete Anne in ihrem ersten Remote-Sales-Job.', '750 € in den ersten 5 Tagen: Direkt zum Einstieg verdiente sie innerhalb von nur fünf Tagen ihre ersten 750 €.', 'Über 1,6 Mio. € Umsatz geclosed: Heute lebt und arbeitet Anne ortsunabhängig, bereist die Welt und hat innerhalb eines Jahres bereits über 1,6 Mio. € Umsatz als Remote-Closerin abgeschlossen.']
}, {
  videoId: 'WwiC2OE3qXA',
  title: 'Wie Anita mit den richtigen Sales-Skills ihr Business auf das nächste Level gebracht hat',
  text: 'Anita war bereits erfolgreiche Unternehmerin im Beauty-Bereich und führte ein eigenes Team. Ihr Ziel: ihre eigenen Sales-Skills und die ihres Teams auf das nächste Level bringen und gleichzeitig ihr Business mit einem Online-Mentoring erweitern. Dieses startete sie während unserer Zusammenarbeit von null.',
  bullets: ['Sales fürs ganze Unternehmen: Anita lernte, Verkaufsgespräche gezielter zu führen und gab ihre neuen Skills direkt an ihr Team weiter.', 'Neues Online-Business aufgebaut: Parallel zu ihrem bestehenden Unternehmen startete sie ihr eigenes Online-Mentoring-Programm von Grund auf.', 'Über 32.000 € im ersten Monat: Mit ihrem neuen Mentoring erzielte Anita innerhalb des ersten Monats bereits über 32.000 € Umsatz.']
}, {
  videoId: 'r4Xpp2r65zk',
  title: 'Wie Nihan von der Bank zum fünfstelligen Remote-Einkommen kam',
  text: 'Nihan arbeitete viele Jahre als Bankkauffrau – mit festen Arbeitszeiten und komplett ortsgebunden. Ihr Wunsch: mehr Freiheit, reisen und endlich online Geld verdienen. Mit ihrem Einstieg bei den Hot Sales Girls wurde daraus ziemlich schnell Realität.',
  bullets: ['Erster Remote-Job im 1. Monat: Bereits wenige Wochen nach ihrem Start sicherte sich Nihan ihren ersten Job im Remote Sales.', 'Nach 5 Monaten fünfstellig: Innerhalb von nur fünf Monaten erreichte sie ihre ersten fünfstelligen Payouts.', 'Von ortsgebunden zu ortsunabhängig: Heute ist Nihan ausgewandert, bereist die Welt und arbeitet von dort, wo andere Urlaub machen.']
}];
const INITIAL_COUNT = 3;
export function Testimonials() {
  const [showAll, setShowAll] = useState(false);
  const visibleTestimonials = showAll ? testimonials : testimonials.slice(0, INITIAL_COUNT);
  return <section id="testimonials" className="relative w-full px-4 py-10 sm:px-6 sm:py-12" data-id="element-361" data-mp="251iaqyprr60h">
      <div className="relative z-10 mx-auto max-w-[1100px]" data-id="element-362" data-mp="24z5kly9uxpcc">
        <div className="text-center" data-id="element-363" data-mp="1lxoip4ws6m89">
          <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-white" data-id="element-364" data-mp="1lukcy33o3ifh">
            Testimonials
          </span>
          <div className="relative inline-block" data-id="element-365" data-mp="1vnrn019crmlw">
            <Sparkle className="animate-sparkle left-4 top-1 h-5 w-5 sm:-left-9 sm:h-7 sm:w-7" data-id="element-366" data-mp="1vojaeossqe13" />
            <Sparkle className="animate-sparkle-fast right-4 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-367" data-mp="1qu5965rgdcoi" />
            <h2 className="font-display text-gold-3d mx-auto max-w-3xl text-2xl font-extrabold uppercase leading-[1.15] sm:text-3xl lg:text-4xl" data-id="element-368" data-mp="1zobkx71r2u93">
              Das sagen unsere Teilnehmerinnen
            </h2>
          </div>
        </div>

        <div className="mt-16 space-y-20 lg:space-y-32" data-id="element-369" data-mp="29nixhs0nukv5">
          {visibleTestimonials.map((item, index) => {
          const isEven = index % 2 === 0;
          return <div key={index} className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-16 ${!isEven ? 'lg:grid-flow-col-dense' : ''}`} data-id="element-370" data-mp="f8ztfl0h09b0" data-mpi={index}>
                {/* Text Content */}
                <motion.div initial={{
              opacity: 0,
              x: isEven ? -30 : 30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.6
            }} className={!isEven ? 'lg:col-start-2' : ''} data-id="element-371" data-mp="2vwzef5xmyi64">
                  <h3 className="font-heading text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-372" data-mp="2c7f9i6ko5u3d">
                    {item.title}
                  </h3>
                  <p className="mt-5 text-sm leading-relaxed text-white/90 sm:text-base" data-id="element-373" data-mp="1y98vwc35eqv5">
                    {item.text}
                  </p>
                  <ul className="mt-6 space-y-4" data-id="element-374" data-mp="3skniik0v4a6o">
                    {item.bullets.map((bullet, i) => {
                  const [boldPart, ...rest] = bullet.split(':');
                  return <li key={i} className="flex items-start gap-3" data-id="element-375" data-mp="3w3cvxd0j7bb6" data-mpi={i}>
                          <span className="gold-icon-shiny mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-white" data-id="element-376" data-mp="3r49t7z80xh6d">
                            <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-377" data-mp="3m5ortwh1crgc" />
                          </span>
                          <p className="text-sm text-white/90" data-id="element-378" data-mp="3h7n95cniuu5e">
                            <strong className="font-semibold text-white" data-id="element-379" data-mp="iogf1r160hsh">{boldPart}:</strong>
                            {rest.join(':')}
                          </p>
                        </li>;
                })}
                  </ul>
                </motion.div>

                {/* Video Placeholder */}
                <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className={`relative aspect-video w-full overflow-hidden rounded-3xl bg-black/20 shadow-2xl backdrop-blur-sm ${!isEven ? 'lg:col-start-1' : ''}`} data-id="element-380" data-mp="3z0nw9xq2ac9">
                  {item.videoId ? <YouTubeEmbed videoId={item.videoId} title={item.title} className="rounded-3xl" data-id="element-381" data-mp="1dzmu0tmj2ca7" /> : <div className="absolute inset-0 flex items-center justify-center border-2 border-dashed border-white/30 rounded-3xl" data-id="element-382" data-mp="1rwtdkqf2sf0h">
                      <div className="flex flex-col items-center gap-3 text-white/60" data-id="element-383" data-mp="1wp2zlvd2kuxh">
                        <PlayIcon className="h-12 w-12" data-id="element-384" data-mp="21ltdcc1ejefq" />
                        <span className="text-sm font-medium" data-id="element-385" data-mp="26lxw68ps8l94">Video Platzhalter</span>
                      </div>
                    </div>}
                </motion.div>
              </div>;
        })}
        </div>

        {testimonials.length > INITIAL_COUNT && <div className="mt-14 text-center" data-id="element-386" data-mp="2wxtyckt3wbrx">
            <button type="button" onClick={() => setShowAll(prev => !prev)} className="btn-gold-shiny inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-387" data-mp="2rvusn49w92rt">
              {showAll ? 'Weniger anzeigen' : 'Mehr Erfahrungen anzeigen'}
              <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${showAll ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-388" data-mp="2d8t5wmn0tjvt" />
            </button>
          </div>}
      </div>
    </section>;
}